<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  
  data() {
    return {
      watchId: null,
      retryTimer: null,
      lastUpdate: 0,
      updateDelay: 10000,
    };
  },

  methods: {
    $_startLocationWatch() {
      if (!('geolocation' in navigator)) {
        console.error('Navegador sem suporte a Geo');
        return;
      }

      this.$_stopWatch();

      // console.log('Iniciando monitoramento de GPS (App.vue)...');

      this.watchId = navigator.geolocation.watchPosition(
        (position) => {
          const now = Date.now();
          
          if (now - this.lastUpdate < this.updateDelay) {
            return; 
          }

          this.lastUpdate = now;

          localStorage.setItem('msUtil_latitude', position.coords.latitude);
          localStorage.setItem('msUtil_longitude', position.coords.longitude);
          
          // console.log(`GPS OK (${new Date().toLocaleTimeString()}):`, position.coords.latitude);
        },
        (error) => {
          console.warn('Erro no GPS (Watch):', error.message, 'Code:', error.code);
          
          localStorage.removeItem('msUtil_latitude');
          localStorage.removeItem('msUtil_longitude');

          if (error.code !== 1) {
            console.log('Tentando reiniciar GPS em 5 segundos...');
            if (this.retryTimer) clearTimeout(this.retryTimer);
            
            this.retryTimer = setTimeout(() => {
              this.$_startLocationWatch();
            }, 5000);
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 30000,
          maximumAge: 0
        }
      );
    },

    $_stopWatch() {
      if (this.watchId) {
        navigator.geolocation.clearWatch(this.watchId);
        this.watchId = null;
      }
      if (this.retryTimer) {
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
      }
    },

    $_handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        // console.log('App voltou ao foco. Verificando GPS...');
        this.lastUpdate = 0; 
        this.$_startLocationWatch();
      }
    }
  },

  mounted() {
    this.$_startLocationWatch();
    document.addEventListener('visibilitychange', this.$_handleVisibilityChange);
  },

  beforeDestroy() {
    this.$_stopWatch();
    document.removeEventListener('visibilitychange', this.$_handleVisibilityChange);
  }
};
</script>

<style>
  body {
    overflow: hidden;
  }
</style>